import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { FisherLicense } from './fisher-license.model';

@Injectable({
  providedIn: 'root'
})
export class PublicLicenseSearchService {

  private readonly licenseSearchUrl = 'licenses/';

  constructor(private readonly http: HttpClient) {
  }

  performSearch(searchParams: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});

    return this.http.get<FisherLicense[]>(this.licenseSearchUrl, { params: searchParams, headers });
  }

}
